"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Activity, CircleCheck, Clock, GraduationCap, LayoutDashboard, Users, Search, Bell, Settings } from "lucide-react";
const ATTENDANCE_DATA = [{
  name: "AI Integration",
  status: "Active",
  time: "08:55 AM"
}, {
  name: "Market Analysis",
  status: "Active",
  time: "08:58 AM"
}, {
  name: "Risk Assessment",
  status: "Pending",
  time: "09:15 AM"
}, {
  name: "Growth Strategy",
  status: "Active",
  time: "08:50 AM"
}, {
  name: "Digital Audit",
  status: "Paused",
  time: "--:--"
}, {
  name: "Financial Model",
  status: "Active",
  time: "08:59 AM"
}, {
  name: "Brand Identity",
  status: "Active",
  time: "08:52 AM"
}, {
  name: "Tech Stack",
  status: "Pending",
  time: "09:05 AM"
}];
const SCROLLING_DATA = [...ATTENDANCE_DATA, ...ATTENDANCE_DATA];
export default function ArchitectingTheFutureOfBusiness() {
  return <section data-section-id="233258" id="architecting-the-future-of-business" className="dark bg-background text-foreground relative overflow-hidden py-20 lg:py-32 min-h-[90vh] flex items-center">
      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes float {
            0%, 100% { transform: translateY(0px) rotateX(2deg) rotateY(-2deg); }
            50% { transform: translateY(-20px) rotateX(0deg) rotateY(0deg); }
          }
          @keyframes scroll-y {
            0% { transform: translateY(0); }
            100% { transform: translateY(-50%); }
          }
          .animate-float-3d {
            animation: float 8s ease-in-out infinite;
            transform-style: preserve-3d;
            perspective: 1000px;
          }
          .animate-scroll-vertical {
            animation: scroll-y 20s linear infinite;
          }
          .glass-panel {
            background: rgba(255, 255, 255, 0.03);
            backdrop-filter: blur(30px);
            -webkit-backdrop-filter: blur(30px);
            border: 1px solid rgba(255, 255, 255, 0.1);
            box-shadow: 0 4px 30px rgba(0, 0, 0, 0.4);
          }
        `
    }} />

      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none -z-10">
        <div className="absolute top-[-10%] right-[-5%] w-[600px] h-[600px] rounded-lg bg-primary/20 blur-[120px]" />
        <div className="absolute bottom-[-10%] left-[20%] w-[500px] h-[500px] rounded-lg bg-secondary/20 blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-[40%_60%] gap-12 lg:gap-8 items-center">
          
          {}
          <div className="flex flex-col gap-8 relative z-10">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary/10 border border-primary/20 text-primary w-fit">
              <Activity className="size-4 animate-pulse" />
              <span className="text-xs font-bold uppercase tracking-widest font-mono">Intelligence Driven</span>
            </div>
            
            <h1 className="text-5xl lg:text-7xl xl:text-8xl font-bold font-default tracking-tighter leading-[1.1]">
              Architecting <br />
              <span className="bg-gradient-to-r from-white via-white to-muted-foreground bg-clip-text text-transparent">
                The Future
              </span>
            </h1>
            
            <p className="text-lg text-muted-foreground font-default max-w-xl leading-relaxed opacity-60">
              Future Mind Consulting (FMC) empowers global enterprises through digital transformation, AI solutions, and strategic innovation. We bridge the gap between today's challenges and tomorrow's growth.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button size="lg" className="rounded-md h-14 px-8 text-base hover:shadow-[0_0_50px_rgba(var(--primary),0.6)] transition-all bg-primary text-primary-foreground font-default" asChild>
                <Link to="/ConnectPage">Book Consultation</Link>
              </Button>
              <Button size="lg" variant="outline" className="rounded-md h-14 px-8 text-base border-white/10 bg-white/5 backdrop-blur-xl hover:bg-white/10 hover:text-foreground transition-all font-default" asChild>
                <Link to="/StrategicPillarsPage">Watch Vision</Link>
              </Button>
            </div>

            <div className="flex items-center gap-6 pt-8 text-sm text-muted-foreground font-mono">
              <div className="flex items-center gap-2">
                <CircleCheck className="size-5 text-primary" />
                <span>AI Strategy</span>
              </div>
              <div className="flex items-center gap-2">
                <CircleCheck className="size-5 text-primary" />
                <span>Digital Growth</span>
              </div>
            </div>
          </div>

          {}
          <div className="relative w-full h-[600px] lg:h-[700px] perspective-[2000px] flex items-center justify-center">
            {}
            <div className="animate-float-3d w-full max-w-[800px] relative z-20">
              
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/30 to-secondary/30 blur-[80px] -z-10 rounded-3xl" />

              <Card className="glass-panel border-t-white/20 border-l-white/20 rounded-3xl overflow-hidden shadow-2xl shadow-black/80">
                {}
                <div className="h-14 border-b border-white/10 bg-black/40 flex items-center justify-between px-4 backdrop-blur-md">
                  <div className="flex items-center gap-2">
                    <div className="flex gap-1.5">
                      <div className="size-3 rounded-md bg-destructive/80" />
                      <div className="size-3 rounded-md bg-yellow-500/80" />
                      <div className="size-3 rounded-md bg-primary/80" />
                    </div>
                    <div className="ml-4 flex items-center gap-2 text-muted-foreground">
                      <LayoutDashboard className="size-4" />
                      <span className="text-xs font-bold font-mono tracking-widest">FMC_OS_V2</span>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="hidden sm:flex items-center gap-2 bg-black/30 rounded-md px-3 py-1.5 border border-white/5">
                      <Search className="size-3 text-muted-foreground" />
                      <span className="text-xs text-muted-foreground w-24 font-mono">Analyze...</span>
                    </div>
                    <Bell className="size-4 text-muted-foreground" />
                    <div className="size-7 rounded-md bg-gradient-to-tr from-primary to-secondary p-[2px]">
                      <div className="size-full rounded-md bg-background border border-background" />
                    </div>
                  </div>
                </div>

                {}
                <div className="p-6 grid grid-cols-1 md:grid-cols-12 gap-6 bg-gradient-to-b from-transparent to-black/40">
                  
                  {}
                  <div className="md:col-span-5 flex flex-col gap-6">
                    <Card className="glass-panel border-white/10 bg-black/30 shadow-lg rounded-2xl">
                      <CardHeader className="pb-3 pt-5 px-5 border-b border-white/5">
                        <CardTitle className="text-sm font-default flex items-center justify-between">
                          <div className="flex items-center gap-2 font-mono uppercase tracking-wider">
                            <Users className="size-4 text-primary" />
                            Active Streams
                          </div>
                          <span className="relative flex size-2">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-md bg-primary opacity-75"></span>
                            <span className="relative inline-flex rounded-md size-2 bg-primary"></span>
                          </span>
                        </CardTitle>
                      </CardHeader>
                      <CardContent className="p-0 h-[280px] overflow-hidden relative mask-image:linear-gradient(to_bottom,transparent,black_10%,black_90%,transparent)">
                        <div className="absolute inset-0 overflow-hidden">
                          <div className="animate-scroll-vertical flex flex-col w-full">
                            {SCROLLING_DATA.map((student, i) => <div key={i} data-index={i} className="flex items-center justify-between p-4 border-b border-white/5 hover:bg-white/5 transition-colors">
                                <div className="flex items-center gap-3">
                                  <div className="size-8 rounded-md bg-muted/50 flex items-center justify-center text-xs font-bold text-foreground font-mono">
                                    {student.name.charAt(0)}
                                  </div>
                                  <div>
                                    <p className="text-sm font-bold text-foreground font-default">{student.name}</p>
                                    <p className="text-xs text-muted-foreground font-mono">{student.time}</p>
                                  </div>
                                </div>
                                <div className={`text-[10px] px-2 py-1 rounded-md border font-mono uppercase ${student.status === 'Active' ? 'bg-primary/10 text-primary border-primary/20' : student.status === 'Pending' ? 'bg-secondary/10 text-secondary border-secondary/20' : 'bg-destructive/10 text-destructive border-destructive/20'}`}>
                                  {student.status}
                                </div>
                              </div>)}
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </div>

                  {}
                  <div className="md:col-span-7 flex flex-col gap-6">
                    {}
                    <Card className="glass-panel border-white/10 bg-black/30 shadow-lg relative overflow-hidden group rounded-2xl">
                      <div className="absolute inset-0 bg-primary/5 animate-pulse" />
                      <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
                        <Clock className="size-24 text-primary -rotate-12" />
                      </div>
                      <CardContent className="p-8 relative z-10 flex flex-col justify-center h-[180px]">
                        <div className="flex items-center gap-2 text-primary mb-2">
                          <Activity className="size-4" />
                          <span className="text-xs font-bold uppercase tracking-widest font-mono">Market Volatility Index</span>
                        </div>
                        <div className="text-5xl font-mono font-bold text-foreground tracking-tighter drop-shadow-[0_0_15px_rgba(0,255,255,0.3)]">
                          0.84<span className="text-primary">.12</span>
                        </div>
                        <div className="text-sm text-muted-foreground mt-2 font-mono uppercase tracking-wider">
                          Real-time Strategic Analysis • FMC Global
                        </div>
                      </CardContent>
                    </Card>

                    {}
                    <div className="grid grid-cols-2 gap-4">
                      <Card className="glass-panel border-white/10 bg-black/30 shadow-lg rounded-2xl">
                        <CardContent className="p-5 flex flex-col gap-1">
                          <GraduationCap className="size-5 text-primary mb-2" />
                          <div className="text-2xl font-bold text-foreground font-default">124%</div>
                          <div className="text-xs text-muted-foreground font-mono uppercase">ROI Growth</div>
                        </CardContent>
                      </Card>
                      <Card className="glass-panel border-white/10 bg-black/30 shadow-lg rounded-2xl">
                        <CardContent className="p-5 flex flex-col gap-1">
                          <Settings className="size-5 text-secondary mb-2" />
                          <div className="text-2xl font-bold text-foreground font-default">AI-9</div>
                          <div className="text-xs text-muted-foreground font-mono uppercase">Core Engine</div>
                        </CardContent>
                      </Card>
                    </div>
                  </div>

                </div>
              </Card>
            </div>
          </div>

        </div>
      </div>
    </section>;
}